import React, { useContext } from 'react';
import { CNAllocationApiData } from './CNAllocationApiTypes';

export const CNAllocationApiContext = React.createContext<CNAllocationApiData | undefined>(
  undefined,
);

export const useCNAllocationApi: () => CNAllocationApiData = () => {
  const data = useContext<CNAllocationApiData | undefined>(CNAllocationApiContext);
  if (!data) {
    throw new Error('CN Allocation API not initialized');
  }
  return data;
};
